export const selectGlobalInvoices = state => state.globalInvoices;
export const selectGlobalInvoicesList = state =>
  selectGlobalInvoices(state).items;
export const selectGlobalInvoicesListCount = state =>
  selectGlobalInvoices(state).count;
export const selectGlobalInvoicesKpis = state => {
  const { totalCartera, collectedInRange, pending } = selectGlobalInvoices(
    state
  );
  return { totalCartera, collectedInRange, pending };
};
export const selectGlobalInvoicesQueryOptions = state => {
  const { options } = selectGlobalInvoices(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};
